import React from "react";
import { CHANNEL_BADGES } from "../../../../core/theme/channelColors";
import BusinessCell from "../../components/BusinessCell";

export default function CompetitorsPage({ competitors }) {
  if (competitors.length === 0) return (
    <div className="bg-white border border-slate-200 rounded-xl px-6 py-16 text-center">
      <p className="text-slate-500 text-sm">No competitor data yet.</p>
    </div>
  );
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">Total Competitors</p>
          <p className="text-3xl font-bold text-slate-900">{competitors.length}</p>
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">Top Competitor</p>
          <p className="text-lg font-bold text-slate-900 truncate">{competitors[0]?.name}</p>
          <p className="text-xs text-slate-400 mt-0.5">Seen {competitors[0]?.total} times</p>
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">Multi-Channel</p>
          <p className="text-3xl font-bold text-slate-900">{competitors.filter(c => c.channelCount > 1).length}</p>
          <p className="text-xs text-slate-400 mt-0.5">Active in 2+ channels</p>
        </div>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-100">
          <h3 className="font-semibold text-slate-800 text-sm">All Competitors Ranked</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-violet-50 text-xs text-slate-400 uppercase tracking-wider">
                <th className="text-left px-6 py-3 font-medium">#</th>
                <th className="text-left px-6 py-3 font-medium">Competitor</th>
                <th className="text-center px-4 py-3 font-medium">Channels</th>
                <th className="text-left px-4 py-3 font-medium">Locations</th>
                <th className="text-left px-4 py-3 font-medium">Keywords</th>
                <th className="text-right px-6 py-3 font-medium">Frequency</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {competitors.map((c, i) => (
                <tr key={c.key} className="hover:bg-violet-50 transition-colors">
                  <td className="px-6 py-3 text-xs text-slate-400 font-mono">{i + 1}</td>
                  <td className="px-6 py-3 font-medium text-slate-800 text-xs max-w-xs"><BusinessCell c={c} /></td>
                  <td className="px-4 py-3"><div className="flex gap-1 justify-center flex-wrap">{CHANNEL_BADGES.filter(ch => c[ch.id] > 0).map(ch => <span key={ch.id} className={`text-xs px-2 py-0.5 rounded font-semibold ${ch.color}`}>{ch.label}</span>)}</div></td>
                  <td className="px-4 py-3"><div className="flex gap-1 flex-wrap">{c.locations.map(l => <span key={l} className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded">{l}</span>)}</div></td>
                  <td className="px-4 py-3"><div className="flex gap-1 flex-wrap">{c.keywords.map(k => <span key={k} className="text-xs bg-violet-50 text-violet-700 border border-violet-100 px-1.5 py-0.5 rounded">{k}</span>)}</div></td>
                  <td className="px-6 py-3 text-right"><span className={`text-sm font-bold ${i === 0 ? "text-red-600" : i < 3 ? "text-amber-600" : "text-slate-600"}`}>{c.total}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
